import * as React from 'react';
import styled from 'styled-components';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { AuthorAchievementInfoItem } from './AuthorAchievementInfoItem';
import { IconSystemV2TeacherOverviewDiploma } from '@doltech/icons/SystemV2/IconSystemV2TeacherOverviewDiploma';
import { IconSystemV2TeacherOverviewGraduateHat } from '@doltech/icons/SystemV2/IconSystemV2TeacherOverviewGraduateHat';
import { IconSystemV2TeacherOverviewPlay } from '@doltech/icons/SystemV2/IconSystemV2TeacherOverviewPlay';
import { isEmpty } from 'lodash';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const Container = styled.div`
  ${verticalSpace(4)};
  max-width: 500px;

  ${fromScreen(768)} {
    ${verticalSpace(8)};
  }
`;


export interface AchievementItemProps {
  key?: string;
  title?: string;
  description?: string;
}

interface AuthorAchievementInfoProps {
  certificates?: AchievementItemProps[];
  degrees?: AchievementItemProps[];
  otherDocuments?: AchievementItemProps[];
}

export const AuthorAchievementInfo = ({ certificates, degrees, otherDocuments }: AuthorAchievementInfoProps) => {
  if (isEmpty(certificates) && isEmpty(degrees) && isEmpty(otherDocuments)) {
    return (
      <ResponsiveTypography.Paragraph color="gray180" variant="regular/14-20">
        -
      </ResponsiveTypography.Paragraph>
    );
  }
  return (
    <Container className="cell-author-detail-info">
      {certificates?.map((eachCertificate, index) => (
        <AuthorAchievementInfoItem
          key={index}
          icon={<IconSystemV2TeacherOverviewDiploma/>}
          highLightText={eachCertificate?.title}
          normalText={eachCertificate?.description}
        />
      ))}
      {degrees?.map((eachDegree, index) => (
        <AuthorAchievementInfoItem
          key={index}
          icon={<IconSystemV2TeacherOverviewGraduateHat/>}
          highLightText={eachDegree?.title}
          normalText={eachDegree?.description}
        />
      ))}
      {otherDocuments?.map((otherDocument, index) => (
        <AuthorAchievementInfoItem
          key={index}
          icon={<IconSystemV2TeacherOverviewPlay/>}
          highLightText={otherDocument?.title}
          normalText={otherDocument?.description}
        />
      ))}
    </Container>
  );
};
